import type { ChatUiRentalTravelerPolicy } from '@voll-intelligence/genui-contract';
import { ShieldCheckIcon } from '@phosphor-icons/react';
import {
  SidePanel,
  SidePanelBody,
  SidePanelContent,
  SidePanelHeader,
  SidePanelTitle,
} from '@voll-intelligence/ui-kit/ui/side-panel';
import { useGenUiI18n } from '../../../../shared/ui/i18n.js';
import '@voll-intelligence/intelligence-ui-kit/flight-offers.css';
import '../../../../shared/ui/flight_ui.css';
import '../../../shared/rental_ui.css';

/**
 * Drawer "Políticas de locação" — display-only. Mostra as políticas do viajante
 * (`rentalPolicyByTraveler`) embutidas no card: um grupo por regra (janela de
 * reserva, categorias, duração etc.) com `description` e `subtitles` opcionais.
 * A casca é o `SidePanel` do DS (`wide`), que abre por cima do drawer de busca;
 * conteúdo em `.rpd-*` (rental_ui.css). Montado = aberto.
 */
export function RentalPolicyDrawer({
  policies,
  onClose,
}: {
  readonly policies: ChatUiRentalTravelerPolicy;
  readonly onClose: () => void;
}) {
  const { t } = useGenUiI18n();
  return (
    <SidePanel
      open
      onOpenChange={(open) => {
        if (!open) onClose();
      }}
    >
      <SidePanelContent size="wide" closeLabel={t('common.close')}>
        <SidePanelHeader>
          <SidePanelTitle>{t('rental.policyDrawer.title')}</SidePanelTitle>
        </SidePanelHeader>
        <SidePanelBody className="rpd-body">
          {policies.name && (
            <div className="rpd-verdict">
              <ShieldCheckIcon size={14} aria-hidden />
              {policies.name}
            </div>
          )}

          <ul className="rpd-groups">
            {/* Esconde grupos sem conteúdo (só título) — ex.: "Orientações da
                empresa" vazio vinha do backend como um header solto. */}
            {policies.policies
              .filter((g) => g.description || g.subtitles.length > 0)
              .map((g, i) => (
                <li key={`${g.title}-${String(i)}`} className="rpd-group">
                  <span className="rpd-gtitle">{g.title}</span>
                  {g.description && <p className="rpd-gdesc">{g.description}</p>}
                  {g.subtitles.length > 0 && (
                    <ul className="rpd-subs">
                      {g.subtitles.map((s, j) => (
                        <li key={`${s.title}-${String(j)}`} className="rpd-sub">
                          <span className="rpd-stitle">{s.title}</span>
                          {s.description && <p className="rpd-sdesc">{s.description}</p>}
                        </li>
                      ))}
                    </ul>
                  )}
                </li>
              ))}
          </ul>
        </SidePanelBody>
      </SidePanelContent>
    </SidePanel>
  );
}
